export default class WindowWatcher {
    constructor() {
      let _callbackList = null;
      _callbackList = new Array();
  
      let _animationReady = true;
  
      let intervalCallback = function () {
        console.log(_callbackList);
        window.requestAnimationFrame(function () {
          for (let callback of _callbackList) {
            callback.callback();
          }
          _animationReady = true;
        }.bind(this));
      }
  
      let scrollWatcher = function () {
        window.addEventListener('scroll', function (e) {
          if (_animationReady) {
            intervalCallback();
            _animationReady = false;
          }
        }.bind(this));
      }
  
      let resizeWatcher = function () {
        window.addEventListener('resize', function (e) {
          if (_animationReady) {
            intervalCallback();
            _animationReady = false;
          }
        }.bind(this));
      }
  
      let htmlSizeWatcher = function () {
        let observerConfig = { attributes: true, childList: false, subtree: false };
        let callback = function () {
          intervalCallback();
        }.bind(this);
  
        let reapply = new MutationObserver(callback);
        try {
          reapply.observe(document.querySelector('html'), observerConfig);
        } catch (e) { console.error(e); }
      }
  
      this.subscribe = function (callback) {
        console.log(callback);
        if (_callbackList.filter(entry => entry.element === callback.element).length == 0) {
          _callbackList.push(callback);
          console.log(_callbackList);
        }
      }.bind(this);
  
      scrollWatcher();
      resizeWatcher();
      htmlSizeWatcher();
    }
  
  }